import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayToast } from "@/utils/toast";
import { ToastType } from "@/enums";

interface SetDefaultOrganizationBody {
  organization_id: number;
}

export const useSetDefaultOrganization = () => {
  const userToken = useAuth()?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation(
    (body: SetDefaultOrganizationBody): Promise<{ message: string; success: boolean }> =>
      fetch(ENDPOINTS.set_default_organization, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
    {
      onSuccess: () => {
        displayToast("Default organization set successfully", ToastType.success);
        queryClient.invalidateQueries([ENDPOINTS.me]);
        queryClient.invalidateQueries([ENDPOINTS.organizations]);
      },
    },
  );
};
